//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const initObjectForm = {
  loading: false,
  keyword: '',
  offset: 0,
  limit: 10,
  sort: 'create_time desc',
  count: 0, // 总数
  slectObjectId: null, // 选择的对象id
  list: [], // 表格数据
};
const initFieldForm = {
  loading: false,
  list: [],
  slectFields: null,
  keyword: '',
};
export default {
  props: {
    objectNames: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showDialog: false,
      activeName: 'object',
      objectForm: {
        ...initObjectForm,
      },
      fieldForm: {
        ...initFieldForm,
      },
    };
  },
  computed: {
    objectListArr() {
      return this.objectForm?.list?.filter((item) =>
        item?.name?.includes(this.objectForm?.keyword),
      );
    },
    fieldListArr() {
      return this.fieldForm?.list?.filter((item) => item?.name?.includes(this.fieldForm?.keyword));
    },
  },
  methods: {
    openDialog() {
      this.showDialog = true;
      this.activeName = 'object';
      this.objectForm = {
        ...initObjectForm,
      };
      this.fieldForm = {
        ...initFieldForm,
      };
      this.getObjectList();
    },
    handleClose() {
      this.showDialog = false;
    },
    handleClick(tab) {
      if (tab.paneName === 'field') {
        this.fieldForm.slectFields = null;
        this.getFieldList();
        return;
      }
      this.$nextTick(() => {
        this.fieldForm.list = [];
      });
    },
    async getObjectList() {
      if (!this.objectNames.length) {
        return;
      }
      try {
        this.objectForm.loading = true;
        const { offset, limit, sort } = this.objectForm;
        const promiseArr = [];
        this.objectNames.forEach((object_name) => {
          promiseArr.push(
            new Promise((resolve) => {
              this.$request({
                url: this.$api.metaGetObjectList,
                data: {
                  offset,
                  limit,
                  sort,
                  object_name,
                },
                showLoading: false,
              }).then((res) => {
                resolve(res.objects);
              });
            }),
          );
        });
        const resArr = await Promise.all(promiseArr);
        this.objectForm.list = resArr.flat();
        this.objectForm.loading = false;
      } catch (err) {
        console.log(err);
        this.objectForm.loading = false;
      }
    },
    handleSelectionChange(row) {
      this.objectForm.slectObjectId = row.id;
    },
    handleSelectionlectFields(row) {
      this.fieldForm.slectFields = row;
    },
    async getFieldList() {
      try {
        this.fieldForm.loading = true;
        const { fields } = await this.$request({
          url: this.$api.metaGetObjectFields,
          data: {
            object_id: this.objectForm.slectObjectId,
          },
        });
        this.fieldForm.list = fields;

        // 已勾选数据处理
        this.$nextTick(() => {
          this.fieldForm.loading = false;
        });
      } catch (err) {
        console.log(err);
        this.$nextTick(() => {
          this.fieldForm.loading = false;
        });
      }
    },
    // 删除已选择的数据
    delSelectField() {
      this.fieldForm.slectFields = null;
    },
    save() {
      this.showDialog = false;
      if (this.fieldForm.slectFields?.name) {
        this.$emit('insertion', `{{${this.fieldForm.slectFields.name}}}`);
      }
    },
  },
};
